import { lazy, Suspense } from 'react';
import { RouteObject, useRoutes } from 'react-router-dom';
import Loading from '~/core/presentation/layout/global/Loading';
import Layout from '~/core/presentation/layout/global/Layout';

const IndexScreen = lazy(() => import('~/core/presentation/pages/index/Index'));
const PrivacyScreen = lazy(() => import('~/core/presentation/pages/privacy/Index'));
const LoginForm = lazy(() => import('~/core/presentation/pages/login/LoginForm'));
const DownloadsScreen = lazy(() => import('~/core/presentation/pages/downloads/Index'));
const VerificarScreen = lazy(() => import('~/core/presentation/pages/verificar/Index'));
// const KyoZapTest = lazy(() => import('~/features/kyozap/WebSocketTest'));
// const AboutScreen = lazy(() => import('~/components/screens/public/about/Index'));
// const ContactScreen = lazy(() => import('~/components/screens/public/contact/Index'));
// const CarrerScreen = lazy(() => import('~/components/screens/public/carrer/Index'));
// const CurriculumScreen = lazy(() => import('~/components/screens/public/curriculum/index'));

function PublicRouter(): JSX.Element {
  const routes: RouteObject[] = [
    {
      path: '/',
      element: <Layout />,
      children: [
        { index: true, element: <IndexScreen /> },
        { path: 'login', element: <LoginForm /> },
        { path: 'privacy', element: <PrivacyScreen /> },
        { path: 'downloads', element: <DownloadsScreen /> },
        { path: 'verificar', element: <VerificarScreen /> },
        // { path: 'kyozap', element: <KyoZapTest /> },

        // { path: 'about', element: <AboutScreen /> },
        // { path: 'contact', element: <ContactScreen /> },
        // { path: 'carrer', element: <CarrerScreen /> },
        // { path: 'curriculum', element: <CurriculumScreen /> },
      ],
    },
  ];

  const element = useRoutes(routes);
  return <Suspense fallback={<Loading />}>{element}</Suspense>;
}

export default PublicRouter;
